import { createContext, useState, useContext, PropsWithChildren } from 'react';
import { RegistrationAnalyticsData } from 'lib/utils/analytics';

export type RegistrationAnalytics = {
  registrationAnalyticsData: RegistrationAnalyticsData[];
  updateRegistrationAnalyticsData: (
    registrationAnalyticsData: RegistrationAnalyticsData[]
  ) => void;
};

export const registrationAnalyticsDefaultValues: RegistrationAnalytics = {
  registrationAnalyticsData: [],
  updateRegistrationAnalyticsData: () => {},
};

const RegistrationAnalyticsContext = createContext<RegistrationAnalytics>(
  registrationAnalyticsDefaultValues
);

const RegistrationAnalyticsProvider = ({ children }: PropsWithChildren) => {
  const [registrationAnalyticsData, setRegistrationAnalyticsData] = useState<
    RegistrationAnalyticsData[]
  >(registrationAnalyticsDefaultValues.registrationAnalyticsData);

  function updateRegistrationAnalyticsData(
    registrationAnalyticsData: RegistrationAnalyticsData[]
  ) {
    setRegistrationAnalyticsData(registrationAnalyticsData);
  }

  return (
    <RegistrationAnalyticsContext.Provider
      value={{
        registrationAnalyticsData: registrationAnalyticsData,
        updateRegistrationAnalyticsData: updateRegistrationAnalyticsData,
      }}
    >
      {children}
    </RegistrationAnalyticsContext.Provider>
  );
};

const useRegistrationAnalytics = () => {
  const { registrationAnalyticsData, updateRegistrationAnalyticsData } =
    useContext<RegistrationAnalytics>(RegistrationAnalyticsContext);

  return {
    registrationAnalyticsData: registrationAnalyticsData,
    updateRegistrationAnalyticsData: updateRegistrationAnalyticsData,
  };
};

export {
  RegistrationAnalyticsContext,
  RegistrationAnalyticsProvider,
  useRegistrationAnalytics,
};
